import { FailedToGetData, H2, Loading } from 'src/components/_commons';
import { MeetingAttendanceTable } from './subcomponents/MeetingAttendanceTable';
import { meetingServices } from 'src/services';
import { setAlertResponse } from 'src/store';
import { typeMeeting } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

export const AdminsMeetingAttendance = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [meetings, setMeetings] = useState<typeMeeting[] | null>(null);
    const [refreshCounter, setRefreshCounter] = useState(0);
    // const [toastMessage, setToastMessage] = useState('');
    // const [toastType, setToastType] = useState<typeAttendanceMessage | null>(null);
    const dispatch = useDispatch();

    // const showToastMessage = (message: string, type: typeAttendanceMessage) => {
    //     setToastMessage(message);
    //     setToastType(type);
    //     setTimeout(() => {
    //         setToastMessage('');
    //         setToastType(null);
    //     }, 5000);
    // }

    useEffect(() => {
        meetingServices.Get().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.meetingsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            const _meetings = [...response.data.meetingsDoc.midweeks, ...response.data.meetingsDoc.publics];
            _meetings.sort((m1, m2) => new Date(m2.date).getTime() - new Date(m1.date).getTime());
            setMeetings(_meetings);
        });
    }, [refreshCounter]);

    if (isLoading) {
        return <Loading mt='80px' />;
    }

    if (!meetings) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'ASISTENCIA A LAS REUNIONES'} />
        <div>
            {/* {toastMessage && toastType &&
                <MeetingAttendanceToast
                    closeModal={() => {
                        setToastMessage('');
                        setToastType(null);
                    }}
                    toastMessage={toastMessage}
                    toastType={toastType}
                />
            } */}
            <MeetingAttendanceTable
                meetings={meetings}
                setRefreshCounter={setRefreshCounter}
            />
        </div>
        {/* <MeetingAttendanceStatistics meetings={meetings} /> */}
        </>
    );
}
